module.exports = __webpack_public_path__ + "static/thirty-3-5c79f4483c425a0761a958fce2313fd0.png";